import { createChart } from "./charts/BaseChart";

import { default as VChartCore } from "@visactor/vchart";

export const VChart = createChart("VChart", {
    vchartConstructor: VChartCore
});